"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Table = require("./Table");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HEADER_TYPE = {
  HEADING: 'heading',
  SUBHEADING: 'subHeading',
  ROWHEADING: 'rowHeading'
};
const stickyStyles = _ref => {
  let {
    cellStickyShadow,
    stickyBackgroundColor,
    type
  } = _ref;
  return (0, _styledComponents.css)(["position:sticky;left:0;z-index:2;clip-path:inset(0 -8px 0 0);", " &::before{content:'';box-shadow:", ";position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none;}"], type !== HEADER_TYPE.SUBHEADING && type !== HEADER_TYPE.HEADING ? `background-color: ${stickyBackgroundColor};` : undefined, cellStickyShadow);
};
const sharedStyles = /*#__PURE__*/(0, _styledComponents.css)(["", ""], _ref2 => {
  let {
    isSticky,
    align,
    cellPaddingTop,
    cellPaddingRight,
    cellPaddingBottom,
    cellPaddingLeft,
    cellBorderWidth,
    cellBorderColor,
    cellBorderTopWidth,
    cellMinWidth,
    cellBackground,
    cellStickyShadow,
    stickyBackgroundColor,
    type
  } = _ref2;
  return (0, _styledComponents.css)(["text-align:", ";min-width:", "px;padding:", "px ", "px ", "px ", "px;background-color:", ";", ";border-style:", ";border-color:", ";border-width:", ";border-top-width:", ";"], align, cellMinWidth, cellPaddingTop, cellPaddingRight, cellPaddingBottom, cellPaddingLeft, cellBackground, isSticky && stickyStyles({
    type,
    cellStickyShadow,
    stickyBackgroundColor
  }), cellBorderWidth || cellBorderTopWidth ? 'solid' : 'none', cellBorderColor, cellBorderWidth, cellBorderTopWidth || cellBorderWidth);
});
const createStyledCell = htmlElement => _styledComponents.default[htmlElement].withConfig({
  displayName: "Cell__createStyledCell",
  componentId: "components-web__sc-ltgfic-0"
})(["", ";box-shadow:", ";", ""], sharedStyles, _ref3 => {
  let {
    cellBoxShadowColor,
    type
  } = _ref3;
  return type === HEADER_TYPE.HEADING ? `inset 0 1px 0 ${cellBoxShadowColor}, inset 0 -1px 0 ${cellBoxShadowColor}` : `inset 0 1px 0 ${cellBoxShadowColor}`;
}, _ref4 => {
  let {
    display
  } = _ref4;
  return display && `*:not(:empty) {
    display: ${display};
  }`;
});
const StyledHeaderCell = createStyledCell('th');
const StyledDataCell = createStyledCell('td');
const Cell = /*#__PURE__*/_react.default.forwardRef((_ref5, ref) => {
  let {
    children,
    isFirstInRow,
    align = 'left',
    tokens: cellTokens,
    type = 'default'
  } = _ref5;
  const {
    text,
    isScrollable: isTableScrollable,
    tokens: tableTokens,
    spacing,
    variant
  } = (0, _Table.useTableContext)();
  const themeTokens = {
    ...tableTokens,
    ...cellTokens
  };
  const {
    cellMinWidth,
    cellBoxShadowColor,
    cellBackground,
    cellStickyShadow,
    cellPaddingTop,
    cellPaddingRight,
    cellPaddingLeft,
    cellPaddingBottom,
    cellBorderWidth,
    cellBorderColor,
    cellBorderTopWidth,
    fontName,
    fontWeight,
    fontSize,
    lineHeight,
    stickyBackgroundColor,
    fontColor,
    display
  } = (0, _componentsBase.useThemeTokens)('Table', themeTokens, {
    spacing,
    type,
    text,
    ...variant
  });
  const sharedProps = {
    align,
    isSticky: isTableScrollable && isFirstInRow,
    cellBackground,
    cellMinWidth,
    cellStickyShadow: (0, _componentsBase.applyShadowToken)(cellStickyShadow).boxShadow,
    cellPaddingTop,
    cellPaddingRight,
    cellPaddingLeft,
    cellPaddingBottom,
    cellBorderWidth,
    cellBorderColor,
    cellBorderTopWidth,
    stickyBackgroundColor,
    cellBoxShadowColor,
    display,
    ref
  };
  const typographyTokens = {
    fontName,
    fontWeight,
    fontSize,
    lineHeight,
    color: fontColor
  };
  switch (type) {
    case HEADER_TYPE.HEADING:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledHeaderCell, {
        scope: "col",
        ...sharedProps,
        type: type,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
          tokens: typographyTokens,
          children: children
        })
      });
    case HEADER_TYPE.SUBHEADING:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledHeaderCell, {
        scope: "col",
        ...sharedProps,
        type: type,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
          tokens: typographyTokens,
          children: children
        })
      });
    case HEADER_TYPE.ROWHEADING:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledHeaderCell, {
        scope: "row",
        ...sharedProps,
        type: type,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
          tokens: typographyTokens,
          children: children
        })
      });
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDataCell, {
        ...sharedProps,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
          tokens: typographyTokens,
          children: children
        })
      });
  }
});
Cell.displayName = 'Cell';
Cell.propTypes = {
  type: _propTypes.default.oneOf(['default', 'heading', 'subHeading', 'rowHeading']),
  tokens: _propTypes.default.object,
  children: _propTypes.default.node,
  /**
   * @ignore
   * Used internally for making the first column sticky
   */
  isFirstInRow: _propTypes.default.bool,
  /**
   * Defines the text alignment within the cell
   */
  align: _propTypes.default.oneOf(['left', 'center', 'right'])
};
var _default = exports.default = Cell;